import { RawContextKey, ContextKeyExpr } from '../../../../platform/contextkey/common/contextkey.js';
import { localize2WithPath, localizeWithPath } from '../../../../nls.js';
import { Codicon } from '../../../../base/common/codicons.js';
import { registerIcon } from '../../../../platform/theme/common/iconRegistry.js';
import { Categories } from '../../../../platform/action/common/actionCommonCategories.js';
const _moduleId = "vs/workbench/services/userDataSync/common/userDataSync";
function getSyncAreaLabel(source) {
    switch (source) {
        case "settings" : return ( localizeWithPath(_moduleId, 0, "Settings"));
        case "keybindings" : return ( localizeWithPath(_moduleId, 1, "Keyboard Shortcuts"));
        case "snippets" : return ( localizeWithPath(_moduleId, 2, "User Snippets"));
        case "tasks" : return ( localizeWithPath(_moduleId, 3, "User Tasks"));
        case "extensions" : return ( localizeWithPath(_moduleId, 4, "Extensions"));
        case "globalState" : return ( localizeWithPath(_moduleId, 5, "UI State"));
        case "profiles" : return ( localizeWithPath(_moduleId, 6, "Profiles"));
        case "workspaceState" : return ( localizeWithPath(_moduleId, 7, "Workspace State"));
    }
}
const SYNC_TITLE = ( localize2WithPath(_moduleId, 8, "Settings Sync"));
const SYNC_VIEW_ICON = registerIcon('settings-sync-view-icon', Codicon.sync, ( localizeWithPath(_moduleId, 9, 'View icon of the Settings Sync view.')));
const CONTEXT_SYNC_STATE = ( (new RawContextKey('syncStatus', "uninitialized" )));
const CONTEXT_SYNC_ENABLEMENT = ( (new RawContextKey('syncEnabled', false)));
const CONTEXT_ACCOUNT_STATE = ( (new RawContextKey('userDataSyncAccountStatus', "unavailable" )));
const CONTEXT_ENABLE_ACTIVITY_VIEWS = ( (new RawContextKey(`enableSyncActivityViews`, false)));
const CONTEXT_ENABLE_SYNC_CONFLICTS_VIEW = ( (new RawContextKey(`enableSyncConflictsView`, false)));
const CONTEXT_HAS_CONFLICTS = ( (new RawContextKey('hasConflicts', false)));
const CONFIGURE_SYNC_COMMAND_ID = 'workbench.userDataSync.actions.configure';
const SHOW_SYNC_LOG_COMMAND_ID = 'workbench.userDataSync.actions.showLog';
const SYNC_VIEW_CONTAINER_ID = 'workbench.view.sync';
const SYNC_CONFLICTS_VIEW_ID = 'workbench.views.sync.conflicts';
const DOWNLOAD_ACTIVITY_ACTION_DESCRIPTOR = {
    id: 'workbench.userDataSync.actions.downloadSyncActivity',
    title: ( localize2WithPath(_moduleId, 10, "Download Settings Sync Activity")),
    category: Categories.Developer,
    f1: true,
    precondition: ( (ContextKeyExpr.and(
         (CONTEXT_ACCOUNT_STATE.isEqualTo("available" )),
         (CONTEXT_SYNC_STATE.notEqualsTo("uninitialized" ))
    )))
};
export { CONFIGURE_SYNC_COMMAND_ID, CONTEXT_ACCOUNT_STATE, CONTEXT_ENABLE_ACTIVITY_VIEWS, CONTEXT_ENABLE_SYNC_CONFLICTS_VIEW, CONTEXT_HAS_CONFLICTS, CONTEXT_SYNC_ENABLEMENT, CONTEXT_SYNC_STATE, DOWNLOAD_ACTIVITY_ACTION_DESCRIPTOR, SHOW_SYNC_LOG_COMMAND_ID, SYNC_CONFLICTS_VIEW_ID, SYNC_TITLE, SYNC_VIEW_CONTAINER_ID, SYNC_VIEW_ICON, getSyncAreaLabel };
